import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const SyaratKetentuan = () => {
  const [lang, setLang] = useState("id");

  useEffect(() => {
    try {
      const stored = localStorage.getItem("terms_lang");
      if (stored === "id" || stored === "en") setLang(stored);
    } catch (e) {
      // ignore
    }
    window.scrollTo(0, 0);
  }, []);

  const setLanguage = (l) => {
    if (l !== "id" && l !== "en") return;
    setLang(l);
    try {
      localStorage.setItem("terms_lang", l);
    } catch (e) {
      // ignore
    }
  };

  const content = {
    id: {
      body: (
        <>
          <h3 className="text-lg font-bold text-slate-700 mb-4">
            Syarat & Ketentuan Penggunaan
          </h3>
          <div className="text-md text-gray-700 space-y-4">
            <p>
              Syarat dan ketentuan berikut mengatur penggunaan website Mountain
              Marathon Festival dengan alamat{" "}
              <a
                href="https://mountainmarathonfestival.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-700 underline"
              >
                mountainmarathonfestival.com
              </a>
              .
            </p>

            <p>
              Dengan mengakses website ini, Anda dianggap telah menyetujui
              syarat dan ketentuan ini. Mohon untuk tidak melanjutkan penggunaan
              website Mountain Marathon Festival apabila Anda tidak menyetujui
              salah satu atau seluruh syarat dan ketentuan yang tercantum di
              halaman ini.
            </p>

            <h4 className="text-md font-semibold text-slate-700">Cookie</h4>
            <p>
              Website ini menggunakan cookie untuk meningkatkan pengalaman
              pengguna. Dengan mengakses website kami, Anda menyetujui
              penggunaan cookie yang diperlukan.
            </p>
            <p>
              Cookie adalah file teks kecil yang disimpan di perangkat Anda oleh
              server website. Cookie ini tidak dapat digunakan untuk menjalankan
              program atau mengirimkan virus. Cookie kami digunakan untuk
              kebutuhan fungsionalitas, analitik, dan pemasaran.
            </p>

            <h4 className="text-md font-semibold text-slate-700">
              Hak Kekayaan Intelektual
            </h4>
            <p>
              Kecuali dinyatakan lain, seluruh hak kekayaan intelektual atas
              konten di website ini dimiliki oleh penyelenggara Mountain
              Marathon Festival dan/atau pemberi lisensinya. Semua hak
              dilindungi oleh undang-undang.
            </p>

            <p>
              Anda diperbolehkan mengakses konten di website ini untuk keperluan
              pribadi, dengan ketentuan sebagai berikut:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Dilarang menyalin atau mempublikasikan ulang materi dari website
                ini.
              </li>
              <li>
                Dilarang menjual, menyewakan, atau mensublisensikan materi dari
                website ini.
              </li>
              <li>
                Dilarang menggandakan, menyalin, atau memproduksi ulang materi
                dari website ini.
              </li>
              <li>Dilarang mendistribusikan ulang konten dari website ini.</li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Komentar Pengguna
            </h4>
            <p>
              Beberapa bagian website memungkinkan pengguna untuk memposting
              komentar atau informasi. Penyelenggara Mountain Marathon Festival
              tidak bertanggung jawab atas konten komentar yang diposting oleh
              pengguna.
            </p>
            <p>Dengan memposting komentar di website ini, Anda menyatakan:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Anda memiliki hak untuk memposting komentar tersebut.</li>
              <li>
                Komentar tidak melanggar hak kekayaan intelektual pihak ketiga.
              </li>
              <li>
                Komentar tidak mengandung materi yang melanggar hukum,
                mencemarkan nama baik, menyinggung, atau melanggar privasi.
              </li>
              <li>
                Komentar tidak digunakan untuk tujuan promosi bisnis atau
                kegiatan ilegal.
              </li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Tautan ke Website Kami
            </h4>
            <p>
              Organisasi berikut diperbolehkan membuat tautan ke website kami
              tanpa izin tertulis:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Lembaga pemerintah</li>
              <li>Mesin pencari</li>
              <li>Kantor berita</li>
              <li>Distributor direktori online yang tercantum</li>
              <li>Bisnis terakreditasi</li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Tanggung Jawab & Penolakan
            </h4>
            <p>
              Kami tidak bertanggung jawab atas konten pihak ketiga yang
              menautkan ke website kami. Informasi di website ini dapat berubah
              tanpa pemberitahuan. Selama website ini disediakan gratis, kami
              tidak bertanggung jawab atas kerugian atau kerusakan apa pun
              sejauh diizinkan oleh hukum.
            </p>
          </div>
        </>
      ),
    },
    en: {
      body: (
        <>
          <h3 className="text-lg font-bold text-slate-700 mb-4">
            Terms & Conditions of Use
          </h3>

          <div className="text-md text-gray-700 space-y-4">
            <p>
              The following terms and conditions govern the use of the Mountain
              Marathon Festival website at{" "}
              <a
                href="https://mountainmarathonfestival.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-700 underline"
              >
                mountainmarathonfestival.com
              </a>
              .
            </p>

            <p>
              By accessing this website you are considered to have accepted
              these terms and conditions. Please do not continue to use the
              Mountain Marathon Festival website if you do not agree with any or
              all of the terms and conditions set out on this page.
            </p>

            <h4 className="text-md font-semibold text-slate-700">Cookies</h4>
            <p>
              This website uses cookies to improve the user experience. By
              accessing our website, you consent to the use of cookies that are
              necessary for the site to function.
            </p>
            <p>
              Cookies are small text files placed on your device by a website's
              server. They cannot be used to run programs or deliver viruses.
              Our cookies are used for functionality, analytics, and marketing.
            </p>

            <h4 className="text-md font-semibold text-slate-700">
              Intellectual Property
            </h4>
            <p>
              Unless otherwise stated, all intellectual property rights in the
              content on this website are owned by the organizer of Mountain
              Marathon Festival and/or its licensors. All rights are reserved
              and protected by applicable law.
            </p>

            <p>
              You may access content on this website for personal use only,
              subject to the following restrictions:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Do not copy or republish material from this website.</li>
              <li>
                Do not sell, rent, or sub-license material from this website.
              </li>
              <li>
                Do not reproduce, duplicate, or otherwise exploit material from
                this website.
              </li>
              <li>Do not redistribute content from this website.</li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              User Comments
            </h4>
            <p>
              Some parts of this website allow users to post comments or other
              information. The organizer of Mountain Marathon Festival is not
              responsible for content posted by users.
            </p>
            <p>By posting comments on this website you represent that:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>You have the right to post the comment.</li>
              <li>
                The comment does not infringe any third-party intellectual
                property rights.
              </li>
              <li>
                The comment does not contain unlawful, defamatory, offensive, or
                privacy-invading material.
              </li>
              <li>
                The comment is not used for business promotion or illegal
                activities.
              </li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Links to Our Website
            </h4>
            <p>
              The following organizations are permitted to link to our website
              without prior written consent:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Government agencies</li>
              <li>Search engines</li>
              <li>News organizations</li>
              <li>Online directory distributors listed</li>
              <li>Accredited businesses</li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Liability & Disclaimer
            </h4>
            <p>
              We are not responsible for third-party content that links to our
              website. Information on this site may change without notice. As
              this website is provided free of charge, we will not be liable for
              any loss or damage arising from its use to the fullest extent
              permitted by law.
            </p>
          </div>
        </>
      ),
    },
  };

  return (
    <section className="w-full min-h-screen py-20 bg-white text-slate-700">
      <div className="container mx-auto max-w-6xl">
        <div className="max-w-6xl mx-auto space-y-6">
          {/* Language switcher (top-right) */}
          <div className="flex px-4 justify-end">
            <div
              className="inline-flex rounded-md shadow-sm"
              role="group"
              aria-label="Language switcher"
            >
              <button
                onClick={() => setLanguage("id")}
                aria-pressed={lang === "id"}
                className={`px-4 py-1 text-sm font-medium transition ${
                  lang === "id"
                    ? "bg-slate-700 text-white rounded-l-md"
                    : "bg-white text-slate-700 border border-slate-200 rounded-l-md"
                }`}
              >
                Bahasa (ID)
              </button>
              <button
                onClick={() => setLanguage("en")}
                aria-pressed={lang === "en"}
                className={`px-4 py-1 text-sm font-medium transition ${
                  lang === "en"
                    ? "bg-slate-700 text-white rounded-r-md"
                    : "bg-white text-slate-700 border border-slate-200 rounded-r-md"
                }`}
              >
                English
              </button>
            </div>
          </div>

          <div className="max-w-6xl mx-auto">
            <motion.div
              className="text-left"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="px-4 py-6 md:px-8 md:py-8">
                <div className="prose prose-lg max-w-none text-gray-700">
                  {content[lang].body}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SyaratKetentuan;
